export const messages = {
  en: {
    inspectionTask: {
      queryConditions: 'Query Conditions',
      executor: 'Executor',
      actualStartTime: 'Actual Inspection Start Time',
      actualEndTime: 'Actual Inspection End Time',
      inspectionStatus: 'Inspection Status',
      query: 'Query',
      reset: 'Reset',
      inspectionTask: 'Inspection Task',
      taskCode: 'Task Code',
      inspectionPlan: 'Inspection Plan',
      inspectorTime: 'Inspector/Start-End Time',
      actualTime: 'Actual Inspection Time',
      plannedInspector: 'Planned Inspector',
      currentInspector: 'Current Inspector',
      transferDesc: 'Transfer Description',
      inspectionMethod: 'Inspection Method',
      operation: 'Operation',
      flow: 'Flow',
      detail: 'Detail',
      delete: 'Delete',
      note: 'Inspection tasks are automatically generated every day at 2 AM based on inspection plans. If not generated, please confirm whether the scheduled task is enabled or if the inspection plan is set correctly.'
    },
    inspectionTaskDetail: {
      taskDetails: 'Task Details',
      inspectionPoint: 'Inspection Point',
      inspectionStatus: 'Inspection Status',
      signStatus: 'Sign Status',
      inspectorTime: 'Inspector/Start-End Time',
      pointTime: 'Point Start/End Time',
      actualTime: 'Actual Inspection Time',
      inspectionSituation: 'Inspection Situation',
      inspectionPhotos: 'Inspection Photos',
      locationInfo: 'Location Info',
      view: 'View',
      start: 'Start',
      end: 'End'
    },
    inspectionTaskTransfer: {
      transfer: 'Transfer',
      transferObject: 'Transfer Object',
      transferDesc: 'Transfer Description',
      required: 'Required, please fill in',
      submit: 'Submit',
      cancel: 'Cancel'
    },
    deleteInspectionTask: {
      confirmOperation: 'Please confirm your operation',
      confirmDelete: 'Confirm deletion of inspection task',
      mistake: 'Mistake',
      confirmDeleteBtn: 'Confirm Delete'
    }
  },
  zh: {
    inspectionTask: {
      queryConditions: '查询条件',
      executor: '执行人',
      actualStartTime: '实际巡检开始时间',
      actualEndTime: '实际巡检结束时间',
      inspectionStatus: '巡检状态',
      query: '查询',
      reset: '重置',
      inspectionTask: '巡检任务',
      taskCode: '任务编码',
      inspectionPlan: '巡检计划',
      inspectorTime: '巡检人/开始结束时间',
      actualTime: '实际巡检时间',
      plannedInspector: '计划巡检人',
      currentInspector: '当前巡检人',
      transferDesc: '转移描述',
      inspectionMethod: '巡检方式',
      operation: '操作',
      flow: '流转',
      detail: '详情',
      delete: '删除',
      note: '巡检任务是根据巡检计划，每天晚上2点钟自动生成，如果没有生成 请确认是否开启了定时任务，或者巡检计划是否设置正确'
    },
    inspectionTaskDetail: {
      taskDetails: '任务详情',
      inspectionPoint: '巡检点',
      inspectionStatus: '巡检状态',
      signStatus: '签到状态',
      inspectorTime: '巡检人/开始结束时间',
      pointTime: '巡检点开始结束时间',
      actualTime: '实际巡检时间',
      inspectionSituation: '巡检情况',
      inspectionPhotos: '巡检照片',
      locationInfo: '位置信息',
      view: '查看',
      start: '开始',
      end: '结束'
    },
    inspectionTaskTransfer: {
      transfer: '流转',
      transferObject: '流转对象',
      transferDesc: '流转说明',
      required: '必填，请填写',
      submit: '提交',
      cancel: '取消'
    },
    deleteInspectionTask: {
      confirmOperation: '请确认您的操作',
      confirmDelete: '确定删除巡检任务',
      mistake: '点错了',
      confirmDeleteBtn: '确认删除'
    }
  }
}